<template>
  <v-dialog
    v-model="isOpen"
    width="500"
  >
    <v-card>
      <v-card-title class="subtitle-1 justify-end pb-0">
        <v-icon @click="close">mdi-window-close</v-icon>
      </v-card-title>
      <v-card-title class="subtitle-1 text-uppercase justify-center pt-0 pb-0">Request VideoAmp Audience</v-card-title>
      <v-card-title class="pt-0 mb-5">
        <v-row class="justify-center">
          <v-progress-linear
            v-show="buttonClicked"
            indeterminate
          ></v-progress-linear>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row class="justify-center">
          <v-autocomplete
            v-model="selectedValue"
            :items="items"
            item-text="name"
            item-value="id"
            label="VideoAmp Audience"
            class="ma-12"
            :menu-props="{ maxWidth: 396 }"
            dense
            clearable
            :item-disabled="item => item.disabled"
            :search-input.sync="search"
            @input="val => $emit('update', val)"
          ></v-autocomplete>
        </v-row>
      </v-card-text>
      <v-card-actions class="justify-center pb-8">
        <action-button
          light
          :disabled="disableRequestAudience"
          @click.native="requestAudience"
          label="Submit"
          color="primary"
          id="requestVideoAmpAudienceBtn"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import XandrAPI from '@/api/XandrAPI'
  import ActionButton from '@/components/common/actionButton'
  import Toast from '@/components/common/toasts'

  export default {
    components: {
      ActionButton,
    },
    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        isOpen: this.value,
        search: null,
        selectedValue: null,
        buttonClicked: false,
      }
    },
    computed: {
      disableRequestAudience() {
        return this.selectedValue === null || this.buttonClicked
      },
      items() {
        return this.$store.state.appRes.videoAmpAudienceList || []
      },
    },
    methods: {
      requestAudience() {
        this.buttonClicked = true
        XandrAPI.requestVideoAmpAudienceIntake(this.selectedValue)
          .then(resp => {
            Toast.success({
              title: `VideoAmp Audience`,
              message: `VideoAmp Audience Intake Request Succeeded`,
            })
            this.close()
          })
          .catch(err => {
            console.log('VideoAmp Audience Request Failed')
            Toast.error({
              title: 'VideoAmp Audience',
              message: `VideoAmp Audience Intake Request Failed: ${err.message}`,
            })
            this.close()
          })
      },
      open() {
        this.isOpen = true
      },
      close() {
        this.selectedValue = null
        this.isOpen = false
        this.buttonClicked = false
      },
    },
    watch: {
      value(val) {
        this.isOpen = val
      },
      isOpen(newVal) {
        if (newVal) {
          this.open()
        }
        this.$emit('input', newVal)
      },
    },
  }
</script>
<style lang="scss">
  .custom-autocomplete .v-menu__content {
    max-width: 396px !important;
  }
</style>



// WEBPACK FOOTER //
// RequestVideoAmpSegment.vue?62c248d6